import React, { Component } from 'react'
import { Row, Col, Table, Menu, Input, Button, Popover, Form, Pagination, Checkbox, Select, Modal, Radio } from 'antd'
import underscore from 'underscore'
import '../../css/mallManage.css'
import { api, app, config } from '../../app'
import utils from '../../utils'
import common from '../mall/common'
import CardCanvas from '../../components/CardCanvas'
import FormModal2 from '../../components/FormModal2'

const FormItem = Form.Item
const Option = Select.Option
const order_state = common.order_state
const RadioGroup = Radio.Group

/**
 * 审核状态
 * @param audit
 * @param vname
 * @param time
 * @returns {*}
 */
function tableStatus(audit, vname, time) {
    if (audit === '0') {
        return (<span>未审核</span>)
    } else {
        return (
            <span>
                <div>{audit === '1' ? '已通过' : '不通过'}</div>
                <div>（{vname}）</div>
                <div>{time}</div>
            </span>
        )
    }
}

/**
 * 查询最后一页
 * @param total
 * @param page
 * @returns {*}
 */
function checkLastPage(total, page) {
    let tp = total % 20 === 0 ? total / 20 : total / 20 + 1
    if (tp <= page) {
        page = tp
    }
    return page
}

class MMOrderList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            menu_current: '10',
            page: 1,
            total: 0,
            orderList: [],
            goodList: [],
            zipList: [],
            selectedRowKeys: [],
            visible: false,
            zip_type: null,
            sel_state: '',
            mall_name: '',
            search_type: 'searchform_no',
            search_val: '',
            refundInfo: {
                method: 'original',
            },
            pageSize: 20
        }
    }

    setData = async (data) => {
        app.setStateSync(this, data)
    }

    async componentDidMount() {
        this._isMounted = true
        let state = app.getData('mall_manage_order_list_state')
        if (state) {
            this.setState(state)
            app.removeData('mall_manage_order_list_state')
        } else {
            this.dataList(1)
            await this.handleGoodList()
        }
        await this.handleZip()
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    /**
     * 选择变更
     * @param selectedRowKeys
     */
    onSelectChange = (selectedRowKeys) => {
        this.setState({ selectedRowKeys })
    }

    /**
     * 数据
     * @param page
     */
    dataList = (page) => {
        this.setState({ data_loading: true }, () => {
            const _this = this, { menu_current, mall_name, search_type, search_val, pageSize } = this.state, params = {
                page,
                mall_name,
                search_val,
                limit: pageSize,
                status: menu_current,
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }
            if (search_val) params.search_type = search_type
            app.post(api.OrdersManageList, params).then(({ flag, data, msg, total = 0 }) => {
                if (_this._isMounted) {
                    if (flag !== 1) {
                        app.alert(msg, 'warn')
                        data = []
                    }
                    _this.setState({ orderList: utils.addArrayKey(data), total: parseInt(total) }, () => {
                        if (_this.state.page === page) {
                            _this.setState({ data_loading: false })
                        }
                    })
                }
            })
        })
    }

    /**
     * Good集合
     * @returns {Promise<void>}
     */
    handleGoodList = async () => {
        const { flag, data, msg } = await app.post(api.MallNameListing)
        if (this._isMounted) {
            if (flag === 1) {
                this.setState({ goodList: data || [] })
            } else {
                this.alert(msg, 'warn')
            }
        }
    }

    /**
     * 菜单点击
     * @param e
     */
    handleMenuClick = (e) => {
        this.setState({ menu_current: e.key, page: 1, selectedRowKeys: [] })
        this.dataList(1)
    }

    /**
     * 跳转订单详情页
     * @param e
     */
    toDetail = (id) => {
        this.props.history.push('/mall-manage/order-detail/' + id)
        app.setData('mall_manage_order_list_state', this.state)
    }

    /**
     * 分页
     **/
    handlePageChange = (page) => {
        this.setState({ page, selectedRowKeys: [] }, () => {
            this.dataList(page)
        })
    }
    /**
     * 全选
     */
    handleAllSel = (e) => {
        const checked = e.target.checked, { orderList } = this.state
        if (checked) {
            const all = underscore.range(1, orderList.length + 1)
            this.setState({ selectedRowKeys: all })
        } else {
            this.setState({ selectedRowKeys: [] })
        }
    }

    /**
     * 搜索内容修改
     * @param e
     */
    handleSearchChange = (e) => {
        const { value } = e.target
        this.setState({ search_val: value })
    }

    /**
     * 搜索类型修改
     * @param e
     */
    handleSearchTypeChange = (value) => {
        // const {value} = e.target;
        this.setState({ search_type: value })
    }

    /**
     * 商品
     * @param e
     */
    handleGoodChange = (value) => {
        // const {value} = e.target;
        this.setState({ mall_name: value })
    }

    /**
     * 搜索
     */
    handleSearch = () => {
        this.setState({ page: 1, total: 0, selectedRowKeys: [] })
        this.dataList(1)
    }

    /**
     * zip列表
     * @returns {Promise<*>}
     */
    handleZip = async () => {
        let { flag, data, msg } = await app.post(api.ZipList, {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        })
        if (flag === 1) {
            await this.setData({ zipList: data || [] })
        } else {
            app.alert(msg, 'warn')
        }
    }

    /**
     * 导出数据
     * @returns {Promise<void>}
     */
    handleExport = async () => {
        let { mall_name, search_val, search_type, menu_current } = this.state
        let url = `${config.serverUrl + api.OrdersExport}?token=${app.getToken()}&indexno=${app.getData('indexno')}&account=${app.getData('account')}&mall_name=${mall_name}&search_val=${search_val}&search_type=${search_type}&status=${menu_current}`
        app.downFile(url)
    }

    /**
     * 导出图片
     * @returns {Promise<void>}
     */
    handleExportImg = async () => {
        await this.handleZip()
        await this.setData({ zip_visible: true, zip_type: 1 })
    }

    /**
     * 删除图片
     * @returns {Promise<void>}
     */
    handleDeleteFile = async () => {
        await this.handleZip()
        await this.setData({ zip_visible: true, zip_type: 2 })
    }

    handleOk = async (values) => {
        if (this.state.submit_loading) return false
        await this.setData({ submit_loading: true })
        let { selectedRowKeys, sel_state, orderList, total, page } = this.state, params = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            orders_id: selectedRowKeys.map((i) => orderList[i - 1].orders_id).join(','),
            status: sel_state,
        }
        values = Object.assign(values, params)
        let { flag, msg } = await app.post(api.OrdersManageStatusEdit, values)
        if (flag === 1) {
            app.alert('提交成功', 'success')
            let lp = checkLastPage(total - selectedRowKeys.length, page)
            await this.setData({ selectedRowKeys: [], page: lp, sel_state: '' })
            this.dataList(lp)
            this.handleCloseModal()
        } else {
            app.alert(msg, 'warn')
        }
        await this.setData({ submit_loading: false })
    }

    handleZipOk = async () => {
        let { zip_id, zip_type } = this.state
        if (!zip_id) {
            app.alert('请选择压缩包!', 'warn')
            return
        }
        if (zip_type === 1) {
            let url = `${config.serverUrl + api.DownloadZip}?token=${app.getToken()}&indexno=${app.getData('indexno')}&account=${app.getData('account')}&id=${zip_id}`
            let flag = app.downFile(url)
            if (flag) {
                this.handleCloseZipModal()
            }
        } else if (zip_type === 2) {
            let { flag, msg } = await app.post(api.ZipUnlink, {
                id: zip_id,
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            })
            if (flag === 1) {
                app.alert('删除成功', 'success')
                this.handleCloseZipModal()
                await this.handleZip()
            } else {
                this.alert(msg, 'warn')
            }
        }
    }

    handleCloseZipModal = () => {
        this.setState({ zip_visible: false, zip_id: '', zip_type: '' })
    }

    /**
     * 商品
     * @param e
     */
    handleZipChange = (value) => {
        this.setState({ zip_id: value })
    }

    /**
     * 关闭对话框
     */
    handleCloseModal = () => {
        this.setState({ visible: false })
    }

    /**
     * 打开对话框
     * @returns {boolean}
     */
    handleOpenModal = () => {
        let { selectedRowKeys, sel_state } = this.state
        if (selectedRowKeys.length === 0) {
            app.alert('请选择订单', 'warn')
            return false
        }
        if (!sel_state) {
            app.alert('请选择状态', 'warn')
            return false
        }
        this.setState({ visible: true })
    }

    /**
     * 选择状态
     **/
    handleSelState = (value) => {
        this.setState({ sel_state: value })

    }

    /**
     * 退款
     **/
    handleRefund = async (params) => {
        if (!params.orders_no) {
            app.alert('请输入订单编号', 'warn')
            return
        }
        if (!params.orders_no) {
            app.alert('请输入退款原因', 'warn')
            return
        }
        await this.setData({ refund_loading: true })
        let { flag, msg } = await app.post(api.OrdersRefund, Object.assign({
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }, params))
        const state = { refund_loading: false }
        if (flag === 1) {
            app.alert(msg, 'success')
            state.refund_visible = false
            await this.setData(state)
            this.dataList(this.state.page)
        } else {
            app.alert(msg, 'warn')
            await this.setData(state)
        }
    }

    /**
     * 打开退款
     **/
    handleOpenRefund = async () => {
        await this.setData({ refund_visible: true })
    }

    /**
     * 关闭退款
     **/
    handleCloseRefund = async () => {
        await this.setData({ refund_visible: false, refund_loading: false })
    }

    /**
    * 修改每页展示数据数量
    **/
    handleSelStatePageSize = async (number) => {
        console.log(number)
        this.setState({ data_loading: true, pageSize: number }, () => {
            const _this = this, page = 1, { menu_current, mall_name, search_type, search_val } = this.state, params = {
                page,
                mall_name,
                search_val,
                limit: number,
                status: menu_current,
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }
            if (search_val) params.search_type = search_type
            // console.log(params)
            app.post(api.OrdersManageList, params).then(({ flag, data, msg, total = 0 }) => {
                if (_this._isMounted) {
                    if (flag !== 1) {
                        app.alert(msg, 'warn')
                        data = []
                    }
                    _this.setState({ orderList: utils.addArrayKey(data), total: parseInt(total) }, () => {
                        if (_this.state.page === page) {
                            _this.setState({ data_loading: false })
                        }
                    })
                }
            })
        })
    }

    render() {
        let {
            orderList, zip_visible, zipList, zip_id, data_loading, search_val, search_type, mall_name, goodList, menu_current,
            page, total, selectedRowKeys, visible, submit_loading, sel_state, refund_visible, refund_loading, refundInfo, pageSize
        } = this.state,
            columns = [
                {
                    title: '订单号',
                    dataIndex: 'out_trade_no',
                    key: 'out_trade_no',
                    width: '10%',
                },
                {
                    title: '商品信息',
                    dataIndex: 'product_info',
                    key: 'product_info',
                    width: '10%',
                    render(text, record) {
                        return (
                            <div>
                                {
                                    (text || []).map((e, i) => {
                                        return (
                                            <p key={i}>{e.mall_name} <span style={{ color: 'red', fontWeight: 'bold' }}>{e.details_nums}</span></p>
                                        )
                                    })
                                }
                            </div>
                        )
                    }
                },
                // {
                //     title: '数量',
                //     dataIndex: 'details_nums',
                //     key: 'details_nums',
                //     width: '8%'
                // },
                {
                    title: '快递单号',
                    dataIndex: 'courier_number',
                    key: 'courier_number',
                    width: '8%',
                    render(text) {
                        return (<span>{text || '暂无'}</span>)
                    }
                },
                {
                    title: '下单时间',
                    dataIndex: 'datetime',
                    key: 'datetime',
                    width: '8%',
                    sorter: (a, b) => a.datetime - b.datetime,
                },
                {
                    title: '购买人',
                    dataIndex: 'vname',
                    key: 'vname',
                    width: '8%'
                },
                {
                    title: '订单状态',
                    dataIndex: 'gstatus',
                    key: 'gstatus',
                    width: '8%',
                    render(text, record) {
                        let state = ''
                        if (record.is_cancel === '1') {
                            state = '已取消'
                        } else if (record.gstatus === '0' && record.trade_status === 'TRADE_SUCCESS') {
                            state = '已付款'
                        } else {
                            let res = underscore.find(order_state, (os) => os.id === record.gstatus)
                            if (res) {
                                state = res.name
                            }
                        }
                        return <span>{state || '未知'}</span>
                    }
                },
                {
                    title: '存心编号',
                    dataIndex: 'bsrno',
                    key: 'bsrno',
                    width: '8%'
                },
                {
                    title: '档案编号',
                    dataIndex: 'indexno',
                    key: 'indexno',
                    width: '10%'
                },
                {
                    title: '队审核状态',
                    dataIndex: 'team_header_is_confirm',
                    key: 'team_header_is_confirm',
                    width: '8%',
                    render(confirm, { detail }) {
                        return (<span>{confirm === 'true' ? '已通过' : (detail ? '不通过' : '未审核')}</span>)
                    }
                },
                {
                    title: '省级审核状态',
                    dataIndex: 'admin_is_onfirm',
                    key: 'admin_is_onfirm',
                    width: '9%',
                    render(confirm, { detail }) {
                        return (<span>{confirm === 'true' ? '已通过' : (detail ? '不通过' : '未审核')}</span>)
                    }
                },
                {
                    title: '操作',
                    dataIndex: '',
                    key: 'cz',
                    width: '5%',
                    render: (text, record, index) => {
                        if (record.subject.indexOf('存心工作证') > -1) {
                            return (
                                <Popover content={<CardCanvas id={index} indexno={record.indexno} />}
                                    title={<div style={{ textAlign: 'center' }}>工作证信息{record.indexno}</div>}
                                    placement="left">
                                    <Button size="small" onClick={() => this.toDetail(record.orders_id)}>详情</Button>
                                </Popover>
                            )
                        } else {
                            return (<Button size="small" onClick={() => this.toDetail(record.orders_id)}>详情</Button>)
                        }
                    }
                },
            ],
            locale = {
                filterTitle: '筛选',
                filterConfirm: '确定',
                filterReset: '重置',
                emptyText: data_loading ? '正在加载中...' : '暂无订单',
            },
            rowSelection = {
                selectedRowKeys,
                onChange: this.onSelectChange,
            },
            formItemLayout = {
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 6 },
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 14 },
                }
            },
            changeChildren = [
                {
                    formItemLayout,
                    label: '备注',
                    name: 'remark',
                    component: (
                        <Input.TextArea placeholder="请输入备注信息" autosize={{ minRows: 4, maxRows: 8 }} />
                    ),
                }
            ]
        if (sel_state === '3') {
            changeChildren.unshift({
                formItemLayout,
                label: '快递公司',
                name: 'courier_company',
                component: (
                    <Input placeholder="请填写快递公司" />
                ),
            }, {
                formItemLayout,
                label: '快递单号',
                name: 'courier_number',
                component: (
                    <Input placeholder="请填写快递单号" />
                ),
            })
        }
        return (
            <div className="mall-manage-order-list">
                <div className="order-menu">
                    <Menu
                        onClick={this.handleMenuClick}
                        selectedKeys={[menu_current]}
                        mode="horizontal"
                    >
                        {
                            order_state.map((status) => <Menu.Item key={status.id}>{status.name}</Menu.Item>)
                        }
                    </Menu>
                </div>
                <div className="order-filter">
                    商品：
                    <Select onChange={this.handleGoodChange} value={mall_name} placeholder="选择商品" style={{ width: 280 }}
                        notFoundContent="暂无商品" showSearch allowClear>
                        {
                            goodList.map((good) => {
                                return (<Option key={good.id} value={good.ppename}>{good.ppename}</Option>)
                            })
                        }
                    </Select>
                    <Input addonBefore="搜索" value={search_val} style={{ width: 360, margin: '0 40px' }}
                        onChange={this.handleSearchChange} addonAfter={
                            <Select value={search_type} style={{ width: 100 }} onChange={this.handleSearchTypeChange}>
                                <Option value="searchform_no">订单编号</Option>
                                <Option value="searchform_name">姓名</Option>
                                <Option value="searchform_bsrno">存心编号</Option>
                                <Option value="searchform_indexno">档案编号</Option>
                            </Select>
                        } />
                    <Button type="primary" onClick={() => this.handleSearch()}>搜索</Button>
                    <Button type="primary" style={{ float: 'right' }}
                        onClick={() => this.handleExport()}>导出数据</Button>
                    <Button type="primary" style={{ float: 'right', margin: '0 20px' }}
                        onClick={() => this.handleExportImg()}>导出图片</Button>
                    <Button type="danger" style={{ float: 'right' }}
                        onClick={() => this.handleDeleteFile()}>删除图片文件</Button>
                    <Button type="primary" style={{ float: 'right', margin: '0 20px' }}
                        onClick={() => this.handleOpenRefund()}>退款</Button>
                </div>
                <Table loading={data_loading} columns={columns} locale={locale}
                    dataSource={orderList} size="small" scroll={{ y: 'calc(100% - 103px)' }}
                    rowSelection={rowSelection}
                    footer={() => {
                        return (
                            <Row type="flex">
                                <div className="action-info">
                                    <div>
                                        <Checkbox
                                            checked={orderList.length !== 0 && selectedRowKeys.length === orderList.length}
                                            onChange={(e) => this.handleAllSel(e)}>全选</Checkbox>
                                    </div>
                                    <div className="state_sel">
                                        <label>状态选择：</label>
                                        <Select value={sel_state} placeholder="选择状态" style={{ width: 160 }}
                                            onChange={this.handleSelState}>
                                            {
                                                order_state.map((os, i) => {
                                                    return ['10', '0', '9'].indexOf(os.id) > -1 ? null : (
                                                        <Option value={os.id} key={i}>{os.name}</Option>)
                                                })
                                            }
                                        </Select>
                                    </div>
                                    <Button type="primary" onClick={() => this.handleOpenModal()}>应用</Button>


                                </div>
                                <div style={{ marginLeft: 550 }}>
                                    每页显示数量：
                                    <Select value={pageSize} placeholder="选择状态" style={{ width: 100 }}
                                        onChange={this.handleSelStatePageSize}>
                                        <Option value={20}>20</Option>
                                        <Option value={50}>50</Option>
                                        <Option value={100}>100</Option>
                                        <Option value={200}>200</Option>
                                    </Select>
                                </div>
                                <Pagination total={total} pageSize={pageSize} current={page} hideOnSinglePage={true}
                                    showTotal={(total) => `总数量：${total}`} className="flex-1"
                                    onChange={(page) => this.handlePageChange(page)} />
                            </Row>
                        )
                    }}
                    pagination={false} />
                <FormModal2 modal={{
                    visible: visible,
                    okText: '提交',
                    cancelText: '取消',
                    maskClosable: false,
                    onCancel: this.handleCloseModal,
                    confirmLoading: submit_loading,
                    destroyOnClose: true,
                }} onSubmit={this.handleOk} children={changeChildren} />
                <Modal
                    title="选择压缩包"
                    visible={zip_visible}
                    okText="提交"
                    cancelText="取消"
                    onOk={this.handleZipOk}
                    onCancel={this.handleCloseZipModal}
                >
                    <Select onChange={this.handleZipChange} value={zip_id} placeholder="选择压缩包" style={{ width: 280 }}
                        notFoundContent="暂无">
                        {
                            zipList.map((zip, i) => {
                                return (<Option key={i} value={zip.id}>{zip.name}</Option>)
                            })
                        }
                    </Select>
                </Modal>

                <FormModal2 modal={{
                    title: '退款',
                    visible: refund_visible,
                    onCancel: this.handleCloseRefund,
                    maskClosable: false,
                    okText: '确定',
                    cancelText: '取消',
                    confirmLoading: refund_loading
                }} onSubmit={this.handleRefund} children={[
                    {
                        formItemLayout,
                        label: '退款方式',
                        name: 'method',
                        options: {
                            rules: [
                                { required: true, message: '请选择退款方式' }
                            ]
                        },
                        component: (
                            <RadioGroup>
                                <Radio value="original">原路退款</Radio>
                                <Radio value="offline">线下退款</Radio>
                            </RadioGroup>
                        )
                    },
                    {
                        formItemLayout,
                        label: '订单编号',
                        name: 'orders_no',
                        options: {
                            rules: [
                                { required: true, message: '请填写订单编号' }
                            ]
                        },
                        component: (
                            <Input />
                        )
                    },
                    {
                        formItemLayout,
                        label: '退款原因',
                        name: 'detail',
                        options: {
                            rules: [
                                { required: true, message: '请填写退款原因' }
                            ]
                        },
                        component: (
                            <Input.TextArea rows={4} />
                        )
                    }
                ]} />
            </div>
        )
    }
}

export default MMOrderList



// WEBPACK FOOTER //
// ./src/routes/mall_manage/MMOrderList.jsx